import { cn } from '@/lib/utils';
import type { CategoriaConcreto } from '@adelante/shared';

/**
 * Badge visual para la categoría del concreto.
 *
 * Colores:
 *   - convencional → gris neutro (default)
 *   - autocompactable → azul (visualmente distinto, recordatorio de
 *     que es otro régimen de fragua y curva de resistencia)
 *   - otro → ámbar (caso excepcional)
 */
const ESTILOS: Record<CategoriaConcreto, { label: string; clase: string }> = {
  convencional: {
    label: 'Convencional',
    clase: 'border-zinc-300 bg-zinc-100 text-zinc-800',
  },
  autocompactable: {
    label: 'Autocompactable',
    clase: 'border-sky-300 bg-sky-50 text-sky-900',
  },
  otro: {
    label: 'Otro',
    clase: 'border-amber-300 bg-amber-50 text-amber-900',
  },
};

interface Props {
  categoria: CategoriaConcreto | null;
  /** Versión compacta (solo 4 letras). Útil en tablas densas. */
  compacto?: boolean;
  className?: string;
}

export function BadgeCategoriaConcreto({ categoria, compacto = false, className }: Props) {
  if (categoria === null) {
    return (
      <span
        className={cn(
          'inline-flex rounded-full border border-dashed border-zinc-300 px-2 py-0.5 text-xs italic text-muted-foreground',
          className,
        )}
        title="Sin categoría asignada"
      >
        —
      </span>
    );
  }

  const e = ESTILOS[categoria];
  const texto = compacto
    ? categoria === 'autocompactable'
      ? 'AUTO'
      : categoria === 'convencional'
        ? 'CONV'
        : 'OTRO'
    : e.label;

  return (
    <span
      className={cn(
        'inline-flex rounded-full border px-2 py-0.5 text-xs font-medium',
        e.clase,
        className,
      )}
      title={e.label}
    >
      {texto}
    </span>
  );
}
